import { booleanProperty, getEnvironmentProps, numberProperty, stringProperty } from '@nimbus/env-props';

declare global {
  interface Window {
    __GENV: Record<string, string>;
  }
}

const isClient = typeof window !== 'undefined';

/**
 * ! When adding new env variable add its process.env key to envVariableKeys as well
 */

export const generalEnv = {
  ...getEnvironmentProps(isClient ? window.__GENV || {} : process.env, {
    env: stringProperty('ENV', { defaultValue: 'prod' }),
    resourcesEnv: stringProperty('RESOURCES_ENV', { defaultValue: 'prod' }),
    nextCommonApiUrl: stringProperty('NEXT_COMMON_API_URL', { defaultValue: 'http://api.dev-thefusebase.com/v2/api' }),
    nextApiPath: stringProperty('NEXT_API_PATH', { defaultValue: '/v2/api' }),
    nimbusDomain: stringProperty('NIMBUS_DOMAIN', { defaultValue: 'dev-thefusebase.com' }),
    appNimbusDomain: stringProperty('APP_NIMBUS_DOMAIN', { defaultValue: 'app.dev-thefusebase.com' }),
    jwtSecret: stringProperty('JWT_SECRET', { defaultValue: 'jwtsecret' }),
    secret: stringProperty('SECRET', { defaultValue: 'devsecret' }),
    superSecret: stringProperty('SUPER_SECRET', { defaultValue: 'devsupersecret' }),
    staticAssetPrefix: stringProperty('STATIC_ASSET_PREFIX', {
      defaultValue: 'https://app.dev-thefusebase.com/box/file/',
    }),
    gatewayUrl: stringProperty('GATEWAY_URL', {
      defaultValue: 'https://app.dev-thefusebase.com/gwapi2',
    }),
    mcpManagerUrl: stringProperty('MCP_MANAGER_URL', {
      defaultValue: 'http://mcp-manager.nimbus.test',
    }),
    userServiceUrl: stringProperty('USER_SERVICE_URL', {
      defaultValue: 'http://user-service.nimbus.test',
    }),
    workspaceServiceUrl: stringProperty('WORKSPACE_SERVICE_URL', {
      defaultValue: 'http://workspace-service.nimbus.test',
    }),
    noteServiceUrl: stringProperty('NOTE_SERVICE_URL', { defaultValue: '' }),
    commentServiceUrl: stringProperty('COMMENT_SERVICE_URL', { defaultValue: '' }),
    taskServiceUrl: stringProperty('TASK_SERVICE_URL', { defaultValue: '' }),
    fileServiceUrl: stringProperty('FILE_SERVICE_URL', { defaultValue: '' }),
    portalServiceUrl: stringProperty('PORTAL_SERVICE_URL', {
      defaultValue: 'http://portal-service.nimbus.test',
    }),
    trialServiceUrl: stringProperty('TRIAL_SERVICE_URL', {
      defaultValue: 'http://trial-service.nimbus.test',
    }),
    bucketServiceUrl: stringProperty('BUCKET_SERVICE_URL', {
      defaultValue: 'http://bucket-service.nimbus.test',
    }),
    permissionsServiceUrl: stringProperty('PERMISSIONS_SERVICE_URL', {
      defaultValue: 'http://permissions-service.nimbus.test',
    }),
    backendGatewayUrl: stringProperty('BACKEND_GATEWAY_URL', {
      defaultValue: '',
    }),
    shortGatewayUrl: stringProperty('SHORT_GATEWAY_URL', {
      defaultValue: '',
    }),
    chatApiUrl: stringProperty('CHAT_API_URL', {
      defaultValue: 'https://chat-rest-api.dev-thefusebase.com/develop',
    }),
    chatWsUrl: stringProperty('CHAT_WS_URL', {
      defaultValue: 'wss://chat-ws-api.dev-thefusebase.com/develop',
    }),
    orgServiceUrl: stringProperty('ORG_SERVICE_URL', { defaultValue: 'http://org-service.nimbus.test' }),
    htmlPublicKey: stringProperty('HTML_PUBLIC_KEY', {
      defaultValue:
        'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEApkh92m5XytQdag/4cqBxegK8F2Yopj+LivFhMfKQSsc5/dB/HA9m4wP7ohj6bkuzr02Uwmdtcxb2jiz5aTb+ikOnPremvNfyATQ2d663VHfpJZfFwamCy6bvLQpY1EkzEvTIsjGdAjl0HDdFKXalKa4KATIigf4wL2SG9getC8kNS0IsP4HFqAovvy0Mx6zY2LfIkm7onl0M2MF4D+YzmGLR/E3RRxrhdnIkPMCkt14TLX+7+ZaLS1yy87WFtyMtaJPpN26+vln0ui5XHIv2W1v4BaMwVHYIs4bnvEWM61JbnqlpJihzQhvW64yD55tEi9FL+JOze0jYrSk+IqMZ0wIDAQAB',
    }),
    dumpServerUrl: stringProperty('DUMP_SERVER_URL', {
      defaultValue: 'https://text.dev-thefusebase.com/dump',
    }),
    tasksBundleJsUrl: stringProperty('TASKS_BUNDLE_JS_URL', {
      defaultValue: 'https://nimbusweb.me/static/tasks-bundle.js',
    }),
    tasksBundleCssUrl: stringProperty('TASKS_BUNDLE_CSS_URL', {
      defaultValue: 'https://nimbusweb.me/static/tasks-bundle.css',
    }),
    localSocketProxy: stringProperty('LOCAL_SOKECT_PROXY', {
      defaultValue: 'ws://localhost:4301/socket.io',
    }),
    commentsBundleJsUrl: stringProperty('COMMENTS_BUNDLE_JS_URL', { defaultValue: '' }),
    embedCodeUrl: stringProperty('EMBED_CODE_URL'),
    gtmId: stringProperty('GTM_ID', { defaultValue: '-' }),
    gtagId: stringProperty('GTAG_ID', { defaultValue: '-' }),
    aiServiceUrl: stringProperty('AI_SERVICE_URL'),
    socketServerUrl: stringProperty('SOCKET_SERVER_URL', { defaultValue: '' }),
    authTokenUrl: stringProperty('AUTH_TOKEN_URL', { defaultValue: '' }),
    chatBundleJsUrl: stringProperty('CHAT_BUNDLE_JS_URL', {
      defaultValue: 'https://nimbusweb.me/static/chat-bundle.js',
    }),
    statsdHost: stringProperty('STATSD_HOST', { defaultValue: 'mock' }),
    statsdDdCompatible: booleanProperty('STATSD_DD_COMPATIBLE', {
      defaultValue: true,
    }),
    businessBillingUrl: stringProperty('BUSINESS_BILLING_URL', { defaultValue: '' }),
    paywallBundleJsUrl: stringProperty('PAYWALL_BUNDLE_JS_URL', { defaultValue: '' }),
    billingServiceUrl: stringProperty('BILLING_SERVICE_URL', { defaultValue: '' }),
    exampleWidget: booleanProperty('EXAMPLE_WIDGET', { defaultValue: false }),
    collectorPath: stringProperty('COLLECTOR_PATH', { defaultValue: '17caef138ede999ee57f79a6170d163c' }),
    snowplowCollectorEndpoint: stringProperty('SNOWPLOW_COLLECTOR_ENDPOINT', { defaultValue: 'http://34.110.191.81' }),
    supersetDomain: stringProperty('SUPERSET_DOMAIN', { defaultValue: 'https://analytics.dev-thefusebase.com' }),
    supersetJwtSecret: stringProperty('SUPERSET_JWT_SECRET', { defaultValue: 'test-guest-secret-change-me' }),
    supersetJwtAud: stringProperty('SUPERSET_JWT_AUD', { defaultValue: 'http://0.0.0.0:8080/' }),
    supersetEmbedId: stringProperty('SUPERSET_EMBED_ID', { defaultValue: 'c25657cf-3c32-49f7-857d-542a168eff94' }),
    supersetDashboardId: stringProperty('SUPERSET_DASHBOARD_ID', { defaultValue: '2' }),
    supersetDatasetId: numberProperty('SUPERSET_DATASET_ID', { defaultValue: 2 }),
    userBillingUrl: stringProperty('USER_BILLING_URL', {
      defaultValue: 'https://nimbusweb.me/user-billing',
    }),
    appAnalyticsServiceUrl: stringProperty('APP_ANALYTICS_SERVICE_URL', { defaultValue: 'http://0.0.0.0:4777' }),
    // only for development purposes, use it to force specific organization to use
    developmentOrgId: stringProperty('DEVELOPMENT_ORG_ID', { defaultValue: '' }),
    docusealEmail: stringProperty('DOCUSEAL_EMAIL', { defaultValue: '' }),
    docusealApiKey: stringProperty('DOCUSEAL_API_KEY', { defaultValue: '' }),
    esignServiceUrl: stringProperty('ESIGN_SERVICE_URL', { defaultValue: '' }),
    purchaseAppsumoBundleUrl: stringProperty('PURCHASE_APPSUMO_BUNDLE_URL', {
      defaultValue: 'https://dev-thefusebase.com/appsumo-subscription-billing/?orgId={orgId}&plan=appsumo-yearly-2023',
    }),
    bookDemoUrl: stringProperty('BOOK_DEMO_URL', { defaultValue: '' }),
    invitesBundleJsUrl: stringProperty('INVITES_BUNDLE_JS_URL', { defaultValue: '' }),
    aiServiceApiUrl: stringProperty('AI_SERVICE_API_URL'),
    fzbAssistantHost: stringProperty('FZB_ASSISTANT_HOST', { defaultValue: 'assistant-api.dev-thefusebase.com' }),
    fzbAssistantHostCreateMessage: stringProperty('FZB_ASSISTANT_HOST_CREATE_MESSAGE', {
      defaultValue: '',
    }),
    adminClientUrl: stringProperty('ADMIN_CLIENT_URL', { defaultValue: 'https://teams.dev-thefusebase.com' }),
    redisHost: stringProperty('REDIS_HOST', { defaultValue: 'redis' }),
    redisPassword: stringProperty('REDIS_PASSWORD'),
    redisPort: numberProperty('REDIS_PORT', { defaultValue: 6379 }),
    hubspotClientId: stringProperty('HUBSPOT_CLIENT_ID', { defaultValue: '' }),
    hubspotClientSecret: stringProperty('HUBSPOT_CLIENT_SECRET', { defaultValue: '' }),
    asanaClientId: stringProperty('ASANA_CLIENT_ID', { defaultValue: '' }),
    asanaClientSecret: stringProperty('ASANA_CLIENT_SECRET', { defaultValue: '' }),
    mondayClientId: stringProperty('MONDAY_CLIENT_ID', { defaultValue: '' }),
    mondayClientSecret: stringProperty('MONDAY_CLIENT_SECRET', { defaultValue: '' }),
    shareBundleJsUrl: stringProperty('SHARE_BUNDLE_JS_URL', {
      defaultValue: 'https://nimbusweb.me/static/sharing-bundle.js',
    }),
  }),
  isClientSide: isClient,
};

export function getGeneralEnvScriptContent() {
  const envVariableKeys = [
    'ENV',
    'ADMIN_CLIENT_URL',
    'RESOURCES_ENV',
    'NEXT_API_PATH',
    'AUTH_TOKEN_URL',
    'STATIC_ASSET_PREFIX',
    'GATEWAY_URL',
    'SHORT_GATEWAY_URL',
    'CHAT_API_URL',
    'CHAT_WS_URL',
    'CACHE_REVALIDATION_SEC',
    'HTML_PUBLIC_KEY',
    'NIMBUS_DOMAIN',
    'APP_NIMBUS_DOMAIN',
    'DUMP_SERVER_URL',
    'TASKS_BUNDLE_JS_URL',
    'TASKS_BUNDLE_CSS_URL',
    'COMMENTS_BUNDLE_JS_URL',
    'WORKSPACE_ID',
    'GTM_ID',
    'GTAG_ID',
    'EMBED_CODE_URL',
    'ORG_SERVICE_URL',
    'AI_SERVICE_URL',
    'SOCKET_SERVER_URL',
    'CHAT_BUNDLE_JS_URL',
    'BUSINESS_BILLING_URL',
    'PAYWALL_BUNDLE_JS_URL',
    'BILLING_SERVICE_URL',
    'EXAMPLE_WIDGET',
    'USER_BILLING_URL',
    'PURCHASE_APPSUMO_BUNDLE_URL',
    'BOOK_DEMO_URL',
    'INVITES_BUNDLE_JS_URL',
    'FZB_ASSISTANT_HOST',
    'FZB_ASSISTANT_HOST_CREATE_MESSAGE',
    'ADMIN_CLIENT_URL',
    'SHARE_BUNDLE_JS_URL',
    'NEXT_COMMON_API_URL',
  ];

  const envs: Record<string, string> = {
    JWT_SECRET: '-',
    SUPER_SECRET: '-',
    USER_SERVICE_URL: '-',
    WORKSPACE_SERVICE_URL: '-',
  };

  for (const key of envVariableKeys) {
    const value = process.env[key];
    if (value != null) {
      envs[key] = value;
    }
  }
  return `(function (window) { window.__GENV = Object.assign(window.__GENV ?? {}, ${JSON.stringify(envs)});})(this);`;
}
